import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { CdssAppointmentModel, UserViseAppointmentReq } from '../../../business-entities/user-vise-appointment-model';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { PagerData } from '../../../business-entities/PagerData';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Filter } from '../../../business-entities/Filter';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe, DecimalPipe } from '@angular/common';
import { UserViseAppointmentService } from '../../../business-services/user-vise-appointment.service';
import { ReceptionService } from '../../../business-services/reception.service';
import { PaginationService } from '../../../services/pagination.service';
import { BrandService } from '../../../business-services/brand.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { AdminCommonService } from '../../../services/admin-common.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-cdss-appointment',
  templateUrl: './cdss-appointment.component.html'
})
export class CdssAppointmentComponent implements OnInit {
  licensePlateClass: string;
  bookingDate: any[] = [];
  todayViewDate: any;
  weekViewDate: any;
  isTodayViewOn: boolean = true;
  isWeekViewOn: boolean = false;
  popupCloseResult = false;
  isAdvanceSearch: boolean = false;
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  userViseAppointmentModel: UserViseAppointmentReq =
    {
      startRecordNumber: 0,
      pageSize: 25,
      sortColumn: '',
      sortDirection: '',
      logDate: '',
      serachTerm: '',
      userId: null,
      isExport:false
    };
  totalCount: number = 0;
  brandList: BrandViewModel[];
  cdssAppointmentList: CdssAppointmentModel[];
  cdssAppointmentExcelList: CdssAppointmentModel[];
  UserList: Array<any>;
  selectedUser = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    searchPlaceholderText: 'Search here',
    maxHeight: 500
  };
  pager: any = {};
  pagerData: PagerData = {
    page: 1,
    pagerSize: Constant.GridPagerSize,
  };
  searchTerm: string;
  pagedItems: any[];
  scrollDistance = 1;
  throttle = 100;
  dataRows: any[] = [];
  filterItems: any[];
  dataList: CdssAppointmentModel[] = [];
  filter: Filter = new Filter();
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private service: UserViseAppointmentService,
    private receptionService: ReceptionService,
    private pagerService: PaginationService,
    private brandService: BrandService,
    private excelService: ExcelService,
    private globalSetting: GlobalSetting,
    private adminCommonSer: AdminCommonService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private decimalPipe: DecimalPipe

  ) { }

  ngOnInit(): void {
    this.licensePlateClass = this.globalSetting.getGlobalLicencePlate();
    this.cdssAppointmentList = [];
    if (this.UserList == undefined) {
      this.getCreatedByUser();
    }
    if (this.brandList == undefined) {
      this.getBrands();
    }
    if (this.service.filterTypeId == 1) {
      this.loadTodayView();
    } else if (this.service.filterTypeId == 2) {
      this.loadWeekView();
    } else {
      this.loadTodayView();
    }
  }
  public getBrands(): Promise<void> {
    return new Promise((resolve, _reject) => {
      this.brandService.getBrand().then((res) => {
        if (res) {
          this.brandList = res;
        }
        resolve()
      });
    })
  }

  loadTodayView() {
    this.isTodayViewOn = true;
    this.isWeekViewOn = false;
    let todays_date = new Date();

    this.weekViewDate = this.datePipe.transform(todays_date, 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(todays_date, 'dd/MM/yyyy');
    this.bookingDate=[];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate = this.datePipe.transform(new Date(), 'dd/MM/yyyy') + ' - ' + this.datePipe.transform(new Date(), 'dd/MM/yyyy');
    this.userViseAppointmentModel.logDate = this.todayViewDate;
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel)
  }

  loadWeekView() {
    this.isTodayViewOn = false;
    this.isWeekViewOn = true;
    //Task 2235
    const  { weekViewDate, bookingDate } =this.adminCommonSer.getWeekViewDatesNew(1);
    this.bookingDate = [...bookingDate];
    this.userViseAppointmentModel.logDate = weekViewDate;
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
  }

  async GetCdssAppointmentList(request) {
    this.spinner.show();
    await this.service.getCdssAppointmentList(this.userViseAppointmentModel).then((res) => {
      if (res?.length > 0) {
        this.cdssAppointmentList.push(...res);
        this.cdssAppointmentList.forEach((element) => {
          element.logo = element.brandCode;
          element.createdDate = element.createdDate ? 
          this.datePipe.transform(new Date(element.createdDate + 'Z'), 'short') : null;
        })

        this.totalCount =
          this.cdssAppointmentList.length > 0
            ? this.cdssAppointmentList[0].totalCount
            : 0;
        this.resetPagerData(
          this.supplierInitiliseGridFromServer(
            this.cdssAppointmentList,
            this.totalCount
          )
        );
        if (this.pagerData.page > 1) {
          this.resetPagerData(
            this.initilisePagerFromServer(
              this.pagerData.page,
              this.pagerData.pagerSize,
              this.totalCount
            )
          );
        }
      }
    }).finally(() => {
      this.spinner.hide();
    })
  }
  onDateRangeChanged(event: any) {
    this.bookingDate = (typeof event === 'undefined') ? [] : event;
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
  }
  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.loadWeekView()
    } else {
      this.loadTodayView()
    }
  }
  refresh() {
    if (this.selectedUser.length > 0) {
      this.userViseAppointmentModel.userId = this.selectedUser.map(x => x.value).join(',')
    }
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
  }
  async getCreatedByUser() {
    await this.receptionService.getCreatedByUserList(true).then((response) => {
      if (response.responseObject?.length > 0) {
        this.UserList = this.mapUser(response.responseObject, true);
      }
    })
  }

  mapUser(array: any[], singleSelection: boolean) {
    let supperArray = [];
    if (array && array.length > 0) {
      if (!singleSelection) {
        let single = Object();
        single.value = '-1'
        single.text = 'All'

        supperArray.push(single);
      }
      array.forEach(element => {
        let single = Object();
        single.value = element.userId
        single.text = element.name
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  onSearch() {
    this.isAdvanceSearch = true;
  }
  onQuickSerch() {
    this.cdssAppointmentList = [];
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.userViseAppointmentModel.serachTerm = this.searchTerm;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 3000);
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
  }
  AdvanceSearchSubmit() {
    let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
    this.userViseAppointmentModel.logDate = bookingDateFormatted;
    this.userViseAppointmentModel.startRecordNumber = 0;
    if (this.selectedUser.length > 0) {
      this.userViseAppointmentModel.userId = this.selectedUser.map(x => x.value).join(',')
    }
    else{
      this.userViseAppointmentModel.userId = null;
    }
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
    this.isAdvanceSearch = false;
  }
  onReset() {
    this.userViseAppointmentModel.serachTerm = null;
    this.userViseAppointmentModel.logDate = null;
    this.userViseAppointmentModel.userId = null;
    this.bookingDate = [];
    this.selectedUser = [];
  }
  onClose() {
    this.onReset();
    this.isAdvanceSearch = false;
  }
  resetPagerData(pageData: any) {
    this.pager = pageData.pager;
    this.pagedItems = pageData.pagedItems;
    pageData.recordSize = this.totalCount;
  }
  async setPage(pagerData: PagerData) {
    if (
      pagerData == null ||
      pagerData === undefined ||
      pagerData.page < 1 ||
      pagerData.page > this.pager.totalPages
    ) {
      return;
    }
    this.pagerData.page = pagerData.page;
    this.pagerData.pagerSize = pagerData.pagerSize;
  }
  async onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.userViseAppointmentModel.sortColumn = column;
    this.userViseAppointmentModel.sortDirection = direction;
    this.userViseAppointmentModel.startRecordNumber = 0;
    this.cdssAppointmentList = [];
    this.GetCdssAppointmentList(this.userViseAppointmentModel);
  }

  onScrollDown() {
    if (this.totalCount > this.cdssAppointmentList?.length) {
      this.userViseAppointmentModel.startRecordNumber = this.cdssAppointmentList.length
      this.GetCdssAppointmentList(this.userViseAppointmentModel);
    }
  }

  supplierInitiliseGridFromServer(data: any[], count: number) {
    if (data != null && data !== undefined) {
      this.dataRows = data;
      return this.refreshGridFromServer(data, count);
    }
    return this.refreshGridFromServer([], 0);
  }

  refreshGridFromServer(data: any[], count: number) {
    this.filterItems = data;
    this.filter.page = data.length === 0 ? 0 : 1;
    return this.initilisePagerFromServer(
      this.filter.page,
      Number(this.filter.pageSize),
      count
    );
  }

  initilisePagerFromServer(
    page: number,
    _pageSize: number,
    count: number = this.filterItems.length
  ) {
    let length =
      this.filterItems.length <= Constant.GridPagerSize
        ? Constant.GridPagerSize
        : this.pagerData.pagerSize;
    this.filter.pageSize = length;
    this.pager = this.pagerService.getPager(count, page, length);
    this.pagedItems = this.filterItems;
    return { pager: this.pager, pagedItems: this.pagedItems };
  }
  public get documentTypes(): typeof Enums.DocumentsType {
    return Enums.DocumentsType;
  }
  //#region  Export functionality
  public async exportAsXLSX() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const excelData = this.mapDataForExport();
    this.excelService.exportAsExcelFile(excelData, `${this.translate.instant('lblCDSSUserAppointment')}`);
    this.spinner.hide();
  }

  public async exportAsPDF() {
    await this.exportData();
    if (this.dataList.length === 0) {
      return;
    }
    this.spinner.show();
    const pdfData = this.mapDataForExport();
    const doc = new jsPDF('landscape');
    autoTable(doc, {
      head: [this.getHeadersForExport()],
      body: pdfData.map(row => Object.values(row)),
      margin: { top: 3, left: 3, right: 3, bottom: 3 },
      styles: { fontSize: 8 },
      columnStyles: {
        0: { cellWidth: 10 },
        1: { cellWidth: 15 },
        2: { cellWidth: 15 },
        3: { cellWidth: 20 },
        4: { cellWidth: 35 },
        5: { cellWidth: 30 },
        6: { cellWidth: 30 },
        7: { cellWidth: 31 }, 
        8: { cellWidth: 25 }, 
        9: { cellWidth: 30, halign: 'right', cellPadding: { top: 2, right: 10, bottom: 2, left: 2 } },
        10: { cellWidth: 22, halign: 'right', cellPadding: { top: 2, right: 6, bottom: 2, left: 2 } },
        11: { cellWidth: 28 },
      }
    });
    doc.save(`${this.translate.instant('lblCDSSUserAppointment')}.pdf`);
    this.spinner.hide();
  }

  private async exportData(): Promise<void> {
    this.spinner.show();
    this.userViseAppointmentModel.isExport = true;
    await this.service.getCdssAppointmentList(this.userViseAppointmentModel).then((res) => {
      if (!res || res.length === 0) {
        this.toastr.error(this.translate.instant('lblDataNotAvailable'));
        this.dataList = [];
        return;
      }
      this.dataList = res;
    }).finally(() => {
      this.userViseAppointmentModel.isExport = false;
      this.spinner.hide();
    })
  }

  private mapDataForExport(): any[] {
    return this.dataList.map((item, index) => ({
      [this.translate.instant('lblNo')]: index + 1,
      [this.translate.instant('lblWoNo')]: item.workorderNumber,
      [this.translate.instant('lblSource')]: item.source,
      [this.translate.instant('lblRegNumber')]: item.licensePlate,
      [this.translate.instant('lblModel')]: item.modelName,
      [this.translate.instant('lblDealersName')]: item.dealerName,
      [this.translate.instant('lblCustomer')]: item.customerName,
      [this.translate.instant('lblUser')]: item.userName,
      [this.translate.instant('lblMobile')]: item.mobileNo ? '+' + item.mobileCode + ' ' + item.mobileNo : '',
      [`${this.translate.instant('lblTotalTime')}${this.translate.instant('lblMinutes')}`]:item.totalTime,
      [this.translate.instant('lblPrice')]: this.decimalPipe.transform(item.totalPrice, '.2-2'),
      [this.translate.instant('lblCreatedDate')]: item.createdDate ?
        this.datePipe.transform(new Date(item.createdDate + 'Z'), 'short') : null,
    }));
  }

  private getHeadersForExport(): string[] {
    return [
      this.translate.instant('lblNo'),
      this.translate.instant('lblWoNo'),
      this.translate.instant('lblSource'),
      this.translate.instant('lblRegNumber'),
      this.translate.instant('lblModel'),
      this.translate.instant('lblDealersName'),
      this.translate.instant('lblCustomer'),
      this.translate.instant('lblUser'),
      this.translate.instant('lblMobile'),
      `${this.translate.instant('lblTotalTime')}${this.translate.instant('lblMinutes')}`,
      this.translate.instant('lblPrice'),
      this.translate.instant('lblCreatedDate'),
    ];
  }
  //#endregion

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }

}
